import { Ng2StateDeclaration } from '@uirouter/angular';
import { FiDocumentStatesResolveDefaultDocumentSettings } from '@fi-app/document/states/resolve/default-document-settings';
import { FiDocumentStatesResolveDefaultTemplateSettings } from '@fi-app/document/states/resolve/default-template-settings';
import { DocumentService } from '@fi-app/document/document.service';
import { DocumentEditComponent } from '@fi-app/document/edit/edit.component';
import { FiDocumentStatesResolvePageTitle } from '@fi-app/document/states/resolve/document-page-title';
import { FiDocumentStatesResolveDocumentTemplates } from '@fi-app/document/states/resolve/document-templates';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiDocumentStatesResolveRecentAIRequests } from '@fi-app/document/states/resolve/recent-ai-requests';

export const FiDocumentCreateState: Ng2StateDeclaration = {
    name: FiStateNames.Document.Add,
    url: '/Add?languageId&closeIFrameAfterSave',
    reloadOnSearch: false,
    views: {
        '@': {
            component: DocumentEditComponent,
        },
    },
    resolve: {
        document: [DocumentService, FiDocumentCreateStateResolveDocumentResolveFunc],
        defaultDocumentSettings: FiDocumentStatesResolveDefaultDocumentSettings,
        defaultTemplateSettings: FiDocumentStatesResolveDefaultTemplateSettings,
        pageTitle: FiDocumentStatesResolvePageTitle,
        documentTemplates: FiDocumentStatesResolveDocumentTemplates,
        recentAIRequests: FiDocumentStatesResolveRecentAIRequests,
    },
};

export function FiDocumentCreateStateResolveDocumentResolveFunc(documentService: DocumentService) {
    return documentService.GetDocument(null);
}
